type Props = {
  color?: string;
  height?: string;
  width?: string;
};

const PadLockIcon = ({
  color = 'black',
  height = '16',
  width = '17'
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33333 4.00001C6.33333 2.80339 7.30338 1.83334 8.5 1.83334C9.69662 1.83334 10.6667 2.80339 10.6667 4.00001V4.66668H6.33333V4.00001ZM5.33333 4.66668V4.00001C5.33333 2.25111 6.7511 0.833344 8.5 0.833344C10.2489 0.833344 11.6667 2.25111 11.6667 4.00001V4.66668H12.5C13.6046 4.66668 14.5 5.56211 14.5 6.66668V12.6667C14.5 13.7712 13.6046 14.6667 12.5 14.6667H4.5C3.39543 14.6667 2.5 13.7712 2.5 12.6667V6.66668C2.5 5.56211 3.39543 4.66668 4.5 4.66668H5.33333ZM3.5 6.66668C3.5 6.11439 3.94772 5.66668 4.5 5.66668H12.5C13.0523 5.66668 13.5 6.11439 13.5 6.66668V12.6667C13.5 13.219 13.0523 13.6667 12.5 13.6667H4.5C3.94772 13.6667 3.5 13.219 3.5 12.6667V6.66668ZM9.16667 9.82163C9.5652 9.59109 9.83333 9.1602 9.83333 8.66668C9.83333 7.9303 9.23638 7.33334 8.5 7.33334C7.76362 7.33334 7.16667 7.9303 7.16667 8.66668C7.16667 9.1602 7.4348 9.59109 7.83333 9.82163V11.6667H9.16667V9.82163Z"
        fill={color}
      />
    </svg>
  );
};

export default PadLockIcon;
